import { Component, Input, OnInit } from '@angular/core';
import {
  calculateTimeFlight,
  getSabreArrivalDate,
  getSabreDepartureDate,
  getSegmentArrivalDate,
  getSegmentDepartureDate,
  parseTime,
} from '@app/utils/functions/srIrops';
/**
 * Componente que muestra la vista del itinerario afectado por IROPs (Irregular Operations).
 * 
 * Este componente maneja la información de los segmentos de vuelo afectados y proporciona detalles
 * sobre horarios de salida, llegada y tiempos de conexión.
 */
@Component({
    selector: 'itinerary-afected-irops-view',
    templateUrl: './itinerary-afected-irops-view.component.html',
    styleUrls: ['./itinerary-afected-irops-view.component.scss'],
    standalone: false
})
export class ItineraryAfectedIropsViewComponent implements OnInit {

 /** Segmento modificado */
 @Input() segModify: any;
  
 /** Primer segmento del itinerario */
 @Input() firstSegment: any;
 
 /** Último segmento del itinerario */
 @Input() lastSegment: any;
 
 /** Primer segmento afectado */
 @Input() firstAfected: any;
 
 /** Itinerario completo */
 @Input() itinerary: any;
 
 /** Línea de ruta */
 @Input() lineRoute: any;
 
 /** Hora del primer segmento afectado */
 @Input() firstAfectedTime: any;
 
 /** Información de escalas */
 @Input() scales: any;
 
 /** Indica si el primer segmento está afectado */
 @Input() isAfectedFirstSeg: any;
 
 /** Indica si el último segmento está afectado */
 @Input() isAfectedLastSeg: any;
 
 /** Segmentos del itinerario */
 @Input() segments: any;

  constructor() { }

  ngOnInit() {
  }
 /**
   * Devuelve el mensaje del banner de cambio de vuelo
   */
  get changeCopyBanner() {
    if(true) { 
      return 'srIrops.IropsBannerChngeYourFlight';
    } else {
      return 'srIrops.goToCounterOrCall';
    }
  }
  /**
   * Obtiene la fecha de salida del primer segmento
   */

  get dateDeparture() {
    return getSabreDepartureDate(this.firstSegment);
  }
 /**
   * Obtiene la fecha de llegada del último segmento
   */
  get dateArrival() {
    return getSabreArrivalDate(this.lastSegment);
  }
 
  get timeItinerary() {
    return parseTime(
      getSabreDepartureDate(this.firstSegment),
      getSabreArrivalDate(this.lastSegment)
    );
  }

  get timeConnecting() {
    return calculateTimeFlight(
      getSegmentArrivalDate(this.firstSegment),
      getSegmentDepartureDate(this.lastSegment)
    );
  }

}
